export class Cookbook {
    BookName: string;
    FullName: string;
    Id_Section: number;
    Id_Book: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/cookbook-model.ts